import { render, staticRenderFns } from "./PostPage.vue?vue&type=template&id=4b7770a2&scoped=true&"
import script from "./PostPage.vue?vue&type=script&lang=ts&"
export * from "./PostPage.vue?vue&type=script&lang=ts&"
import style0 from "./PostPage.vue?vue&type=style&index=0&id=4b7770a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7770a2",
  null
  
)

export default component.exports